import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { filter, first, takeUntil } from 'rxjs/operators';

import { Document } from '@vi-iot/client';

import { BookingStore, DocumentsStore } from '@store';

@Component({
  selector: 'app-booking-contingent-subscriptions-summary',
  templateUrl: './booking-contingent-subscriptions-summary.component.html',
  styleUrls: ['./booking-contingent-subscriptions-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingContingentSubscriptionsSummaryComponent implements OnInit, OnDestroy {
  readonly voucherPrice = '0,00';

  @Input() anyInstallationSelected: boolean;
  @Input() isCheckout: boolean;
  @Output() continue = new EventEmitter<void>();

  tosAccepted = false;
  document: Document;
  currency: string;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public bookingStore: BookingStore,
    private documentsStore: DocumentsStore,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.handleSubscriptions();
    this.documentsStore.getDocuments();
  }

  onTosCheckboxChange(isTosAccepted: boolean): void {
    this.tosAccepted = isTosAccepted;
  }

  isContinueDisabled(): boolean {
    if (this.document) {
      const tosNotAcceptedOnCheckout = this.isCheckout && !this.tosAccepted;

      return tosNotAcceptedOnCheckout || !this.anyInstallationSelected;
    } else {
      return this.isCheckout || !this.anyInstallationSelected;
    }
  }

  onContinue(): void {
    this.continue.emit();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.bookingStore.resetSubscriptionsDetails();
  }

  private handleSubscriptions(): void {
    this.documentsStore.state$
      .pipe(
        filter((state) => !!state?.documents),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe(() => {
        this.subscribeToTermsOfUseDocument();
      });

    this.bookingStore.getCurrencyOfProPackage$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((currency) => {
        this.currency = currency;
        this.cdr.detectChanges();
      });
  }

  private subscribeToTermsOfUseDocument(): void {
    this.documentsStore.termsOfUseDocument$.pipe(first()).subscribe((document) => {
      this.document = document;
      this.cdr.detectChanges();
    });
  }
}
